import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { StatsBar } from './components/sections/StatsBar';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { PainPoints } from './components/sections/PainPoints';
import { Tomos } from './components/sections/Tomos';
import { Deliverables } from './components/sections/Deliverables';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { About } from './components/sections/About';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
const HERO_CTA_ID = 'hero-cta';
export function App() {
  return <div className="w-full min-h-full bg-cream-50 pb-24 sm:pb-28" data-id="element-0" data-mp="3ijxoypkvdyjd">
      <MetaPixel data-id="element-1" data-mp="3ijpe138b53at" />
      <main className="w-full" data-id="element-2" data-mp="3ii4qvyobommz">
        <Hero ctaAnchorId={HERO_CTA_ID} data-id="element-3" data-mp="3mkrd9k285fcs" />
        <StatsBar data-id="element-4" data-mp="3mjq2lgp4euvl" />
        <BeforeAfter data-id="element-5" data-mp="3mj6jvxrnc2gi" />
        <PainPoints data-id="element-6" data-mp="3rcj31sdk3h1v" />
        <Tomos data-id="element-7" data-mp="3rdaquh0wwahl" />
        <Deliverables data-id="element-8" data-mp="3rdkkqfp2v1sk" />
        <Bonuses data-id="element-9" data-mp="3recd7hndojem" />
        <Offer data-id="element-10" data-mp="5yimri0b7dt" />
        <Guarantee data-id="element-11" data-mp="6hrlipoilfp" />
        <Testimonials data-id="element-12" data-mp="4wxfu7a14id" />
        <About data-id="element-13" data-mp="5gbgztt38r4" />
        <Faq data-id="element-14" data-mp="82j0zgp5o9c" />
        <FinalCta data-id="element-15" data-mp="2zl3azit8d249" />
      </main>
      <FloatingCta anchorId={HERO_CTA_ID} data-id="element-16" data-mp="2zlv8x0aavbxp" />
      <PurchasePopup data-id="element-17" data-mp="2zn6actg9w7ln" />
    </div>;
}